import request from '@/utils/request'
const PURCHASE_URL = "http://wsjtoa.com:8098/"


// 首页栏目父子级类型
export function getTProjectTypeListByIndex() {
  return request({
    url: '/api/pc/getTProjectTypeListByIndex',
    method: 'get'
  })
}
// 栏目内容分页列表
export function selectTNewsPage(params) {
  return request({
    url: '/api/pc/selectTNewsPage',
    method: 'get',
    params
  })
}
// 互动交流-新增留言
export function addTMessageArea(data) {
  return request({
    url: '/api/pc/addTMessageArea',
    method: 'post',
    data
  })
}
// 互动交流-合作伙伴
export function selectTPartnerPage(params) {
  return request({
    url: '/api/pc/selectTPartnerPage',
    method: 'get',
    params
  })
}

// 互动交流-联系我们-关于我们
export function getTAboutUsInfo(params) {
  return request({
    url: '/api/pc/getTAboutUsInfo',
    method: 'get',
    params
  })
}

// 首页轮播图
export function getTBannerList() {
  return request({
    url: '/api/pc/getTBannerList',
    method: 'get'
  })
}

// 栏目内容详细信息
export function getTNewsInfo(params) {
  return request({
    url: '/api/pc/getTNewsInfo',
    method: 'get',
    params
  })
}

// 根据字典类型查询字典数据信息（t_friend_link:友情链接类型）
export function getTypeAPI(dictType) {
  return request({
    url: '/api/pc/type/' + dictType,
    method: 'get'

  })
}

// 友情链接
export function getTFriendLinkList(params) {
  return request({
    url: '/api/pc/getTFriendLinkList',
    method: 'get',
    params
  })
}

// 公告列表
export function selectTNoticePage(params) {
  return request({
    url: '/api/pc/selectTNoticePage',
    method: 'get',
    params
  })
}

// 公告详情
export function getTNoticeInfo(params) {
  return request({
    url: '/api/pc/getTNoticeInfo',
    method: 'get',
    params
  })
}

//  服务企业新闻列表
export function selectTEnterpriseNewsPage(params) {
  return request({
    url: '/api/pc/selectTEnterpriseNewsPage',
    method: 'get',
    params
  })
}

// /服务企业新闻详情
export function getTEnterpriseNewsInfo(params) {
  return request({
    url: '/api/pc/getTEnterpriseNewsInfo',
    method: 'get',
    params
  })
}

// /产品发布分页列表
export function selectTProductReleasePage(params) {
  return request({
    url: '/api/pc/selectTProductReleasePage',
    method: 'get',
    params
  })
}

// 产品详情
export function getTProductReleaseInfo(params) {
  return request({
    url: '/api/pc/getTProductReleaseInfo',
    method: 'get',
    params
  })
}


// 获取招投标列表
export function getpurchase(params) {
  return request({
    url: `${PURCHASE_URL}/purchase/project/purchase/list`,
    method: 'post',
    params
  });
}